import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Tooltip, Skeleton, Column } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';
import { FolderPenIcon } from 'components/Icons';

interface CreatedByProps {
  children?: never;
  id: string;
}

export function CreatedBy({ id }: CreatedByProps): JSX.Element {
  const { t } = useLang();

  const { data, errorOrLoading } = loaders.users.find.use({
    blockLoad: !id,

    params: { id },
  });

  if (errorOrLoading) return <Skeleton circle width={20} height={20} />;

  return (
    <Tooltip
      position="right"
      arrow
      ensurePresence
      clickable
      content={
        <Column gap="2">
          <span className="font-medium">{t('created-by')}</span>

          <UserAvatar user={data!} size={32} name nameClassName="font-medium" nameGap="4" />
        </Column>
      }
    >
      <FolderPenIcon size={20} />
    </Tooltip>
  );
}
